<template>
  <div class="menu" :class="{ isCollapse: isCollapse }">
    <div class="info">
      <SideMenuDrop />
    </div>

    <div class="menu-main">
      <el-menu
        :default-active="route.path"
        :default-openeds="[]"
        :collapse="isCollapse"
        text-color="#43445C"
        :active-text-color="'var(--current-color)'"
        popper-class="side-menu"
        router
      >
        <menu-item
          v-for="route in menus"
          :key="route.path"
          :item="route"
          :base-path="route.path"
          :unhandledStoresList="unhandledStoresList"
        />
      </el-menu>
    </div>
    <div class="menu-footer" @click="toggleCollapse()">
      <el-icon
        style="margin-right: 5px"
        :class="isCollapse ? 'is-open' : 'is-close'"
      >
        <Back />
      </el-icon>
      <Transition>
        <span v-if="!isCollapse">{{ $t('collapsemenu') }}</span>
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { MenuStore } from '@/store/modules/menu'
import menuItem from './menuItem.vue'
import SideMenuDrop from './sidemenudrop/index.vue'
import useStoreStore from '../../store/modules/store'
import { getUnhandledStores } from '@/api/common'

const router = useRouter()
const menuStore = MenuStore()
const unhandledStoresList = ref([])
const route = computed(() => router.currentRoute.value)
const menus: any = computed(() => router.options.routes)

const { isCollapse } = storeToRefs(menuStore)

const toggleCollapse = () => {
  menuStore.setCollpase()
}

const queryRedStatus = async () => {
  try {
    const res = await getUnhandledStores()
    if (res.success && Array.isArray(res.data)) {
      unhandledStoresList.value = res.data
    } else {
      unhandledStoresList.value = []
    }
    console.log('unhandledStoresList.value=', unhandledStoresList.value)
  } catch (error) {
    console.error('Failed to obtain the audit list:', error)
  }
}

onMounted(() => {
  queryRedStatus()
})
</script>

<style lang="scss" scoped>
.info {
  height: 70px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  // &:hover {
  //   background-color: #ebf3f2;
  // }
}
.el-menu {
  border-right: none;
  :deep(.el-menu-item),
  :deep(.el-sub-menu__title) {
    margin: 0 12px;
  }
  // :deep(.el-sub-menu__title) {
  //   margin: 0 12px;
  // }
  &.el-menu--collapse {
    :deep(.el-menu-item, ),
    :deep(.el-sub-menu__title) {
      margin: 0;
    }
  }
  :deep(.el-sub-menu.is-active.is-opened) {
    .el-sub-menu__title {
      color: $primary-active-color;
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: -12px;
        transform: translateY(-50%);
        width: 9px;
        height: 36px;
        background-color: var(--el-color-primary);
        mask-image: url('https://file.securepago.com/ny/web/1718612112329_Polygon 1.png');
        mask-repeat: no-repeat;
        mask-position: center center;
        -webkit-mask-image: url('https://file.securepago.com/ny/web/1718612112329_Polygon 1.png');
        -webkit-mask-repeat: no-repeat;
        -webkit-mask-position: center center;
      }
    }
  }
  :deep(.el-menu-item.is-active) {
    background-color: var(--tab-active-bg-color);
    border-radius: 8px;
    &:not(.el-sub-menu.is-active.is-opened .el-menu-item)::before {
      content: '';
      position: absolute;
      top: 50%;
      left: -12px;
      transform: translateY(-50%);
      width: 9px;
      height: 36px;
      background-color: var(--el-color-primary);
      mask-image: url('https://file.securepago.com/ny/web/1718612112329_Polygon 1.png');
      mask-repeat: no-repeat;
      mask-position: center center;
      -webkit-mask-image: url('https://file.securepago.com/ny/web/1718612112329_Polygon 1.png');
      -webkit-mask-repeat: no-repeat;
      -webkit-mask-position: center center;
    }
  }
  :deep(.el-menu-item:hover) {
    color: $primary-active-color;
  }
  :deep(.el-sub-menu__title:hover) {
    color: $primary-active-color;
  }
}

.menu {
  box-sizing: border-box;
  height: 100%;
  transition: all 0.3s ease;
  border-right: 1px solid #ececec;
  max-width: 400px;
  min-width: 65px;
  width: 305px;

  &.isCollapse {
    width: 65px;
  }

  .menu-main {
    overflow-y: auto;
    height: calc(100vh - 56px - 70px - 56px);
  }
  .menu-footer {
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    border-top: 1px solid #ececec;
    font-size: 16px;
    &:hover {
      background-color: var(--el-menu-hover-bg-color);
      color: $primary-active-color;
    }
  }
  .is-open {
    transform: rotate(180deg);
  }
  .is-close {
    transform: rotate(0deg);
  }
}
</style>
